import axios from 'axios';
import Vue from 'vue';

// Shared by both login dialogs. Closing a dialog does not cancel a bank write.
const pending = Vue.observable({});
let sequence = 0;

export default {
  data() {
    return { attemptId: null, restartRequested: false, authViewGeneration: 0, authDestroyed: false };
  },
  computed: {
    loading() { return Boolean(pending[this.providerId]); },
  },
  watch: {
    providerId() { this.resetAuthView(); },
  },
  beforeDestroy() {
    this.authDestroyed = true;
    this.authViewGeneration += 1;
  },
  methods: {
    resetAuthView() {
      this.authViewGeneration += 1;
      this.attemptId = null;
      this.restartRequested = false;
      this.regenerateDevice = false;
      this.resetAuthForm();
    },
    onOpen() { this.resetAuthView(); },
    onClose() { this.resetAuthView(); },
    restart() {
      if (this.loading || !this.attemptId) return;
      // Keep the current attempt id: the server must authorize its replacement.
      this.authViewGeneration += 1;
      this.restartRequested = true;
      this.resetAuthForm();
    },
    isCurrentAuthView(generation, providerId) {
      return !this.authDestroyed && this.authViewGeneration === generation && this.providerId === providerId;
    },
    completeAuthView() {
      this.stage = 'done';
      const generation = this.authViewGeneration;
      const providerId = this.providerId;
      setTimeout(() => {
        if (!this.isCurrentAuthView(generation, providerId)) return;
        this.$emit('success');
        this.localShow = false;
      }, 1200);
    },
    async post(url, payload, isStart = false) {
      const providerId = this.providerId;
      if (!providerId || pending[providerId]) return;
      if (!isStart && !this.attemptId) { this.setError('ATTEMPT_MISMATCH'); return; }
      const body = { ...payload };
      if (!isStart || this.restartRequested) body.attempt_id = this.attemptId;
      if (isStart && this.restartRequested) body.restart = true;
      const owner = ++sequence;
      const generation = this.authViewGeneration;
      Vue.set(pending, providerId, owner);
      try {
        const res = await axios.post(url, body);
        if (!this.isCurrentAuthView(generation, providerId)) return;
        if (res.data && res.data.attempt_id) this.attemptId = res.data.attempt_id;
        if (res.data && res.data.status === true) {
          this.restartRequested = false;
          this.regenerateDevice = false;
        }
        this.handleResult(res.data, isStart);
      } catch (error) {
        if (!this.isCurrentAuthView(generation, providerId)) return;
        if (error.response && error.response.status === 401) {
          await this.$router.push({ name: 'login' });
          return;
        }
        if (error.response && error.response.data) {
          const data = error.response.data;
          if (data.attempt_id) this.attemptId = data.attempt_id;
          this.handleResult(data, isStart);
        } else {
          this.setError('HTTP_ERROR');
        }
      } finally {
        if (pending[providerId] === owner) Vue.delete(pending, providerId);
      }
    },
  },
};
